import {testIdProps} from '@github-ui/test-id-props'
import {PulseIcon} from '@primer/octicons-react'
import {memo} from 'react'

import contentStyles from './content.module.css'
import {SidePanelToolbar} from './header'
import styles from './recap-content.module.css'

// Mock weekly insight data - this will eventually come from the Scribe service
const insights = [
  'Cycle time jumped 25% vs your last sprint, mostly due to unplanned bug fixes.',
  'PR reviews are bottlenecked, consider adding another reviewer this week.',
  'Your team shipped 18 issues, 10% fewer than usual, mostly because of dependency reviews.',
]

export const RecapContent = memo(function RecapContent() {
  return (
    <div className={contentStyles.infoPanelContainer} {...testIdProps('side-panel-recap-content')}>
      <div className={contentStyles.infoPanelContent}>
        <div className={contentStyles.infoPanelHeader}>
          <SidePanelToolbar showCloseButton />
          <div className={contentStyles.headerSpacer} />
          <h2>Recap</h2>
        </div>

        <div className={styles.insightCard}>
          <div className={styles.insightHeader}>
            <h2 className={styles.insightTitle}>Weekly insights</h2>
            <span className={styles.insightDate}>Generated on Oct 24</span>
          </div>
          <ul className={styles.insightList}>
            {insights.map((insight, idx) => (
              <li key={idx} className={styles.insightItem}>
                <PulseIcon size={16} aria-hidden="true" />
                <span className={styles.insightText}>{insight}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
})

try{ RecapContent.displayName ||= 'RecapContent' } catch {}